import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { WaremaButton } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-no-appointment-request-search-results',
    templateUrl: './no-appointment-request-search-results.component.html',
    styleUrls: ['./no-appointment-request-search-results.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, WaremaButton],
})
export class NoAppointmentRequestSearchResultsComponent {
    public readonly isQuotation = input<boolean>(false);

    public readonly findDealer = output<void>();
}
